<template>
  <div class="sr-alert">
    <el-alert
      :class="{ description: description ? true : false }"
      :title="title"
      :type="type"
      :show-icon="showIcon ? true : false"
      :description="description ? description : ''"
      :closable="closable ? true : false"
    >
    </el-alert>
  </div>
</template>

<!--
  功能：功能描述
  汪振涛
  时间：2021年06月01日 15:18:26
  版本：v1.0
-->
<script>
export default {
  components: {},
  props: {
    title:{
      type:String,
      default(){
        return ""
      }
    },
    type: {
      type: String,
      default() {
        return "success";
      },
    },
    showIcon: {
      type: Boolean,
      default() {
        return true;
      },
    },
    closable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    description: {
      type: [Boolean, String],
      default() {
        return "";
      },
    },
  },
  name: "SrAlert",
  data() {
    return {};
  },
};
</script>


// WEBPACK FOOTER //
// packages/SrAlert/SrAlert.vue